import React from "react";

const ParamInfo = () => {
    return (
        <div className="dynamic-parameter-info">
            <p className="dynamic-parameter-info__text">
                <span>Search Query: </span> <span>[Q]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Click ID:</span> <span>[CLICK_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Ad account ID:</span> <span>[AD_ACCOUNT_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>UTM source:</span> <span>[UTM_SOURCE]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Ad group ID:</span> <span>[AD_GROUP_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Ad placement ID:</span> <span>[AD_PLACEMENT_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Ad ID:</span> <span>[AD_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Pixel ID:</span> <span>[PIXEL_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Conversion event:</span> <span>[CONVERSION_EVENT]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>UT:</span> <span>[UT]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Site ID:</span> <span>[SITE_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Site domain:</span> <span>[SITE_DOMAIN]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Publisher ID:</span> <span>[PUBLISHER_ID]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>Publisher name:</span> <span>[PUBLISHER_NAME]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>R:</span> <span>[R]</span>
            </p>
            <p className="dynamic-parameter-info__text">
                <span>TID:</span> <span>[TID]</span>
            </p>
        </div>
    );
};

export default ParamInfo;
